class StickyAddToCart {
  constructor() {
    this.stickyContainer = document.getElementById('sticky-add-to-cart');
    this.originalForm = document.querySelector('product-form');
    this.variantSelector = document.querySelector('variant-radios, variant-selects');
    this.stickyButton = this.stickyContainer.querySelector('.sticky-add-to-cart-button');
    this.productInfo = this.stickyContainer.querySelector('.sticky-product-info');

    this.init();
  }

  init() {
    this.setupEventListeners();
    this.updateStickyAddToCart(this.getSelectedVariant());
  }

  setupEventListeners() {
    window.addEventListener('scroll', () => this.toggleStickyVisibility());
    this.variantSelector.addEventListener('change', () => this.handleVariantChange());
    this.stickyButton.addEventListener('click', () => this.handleStickyAddToCart());
  }

  toggleStickyVisibility() {
    const rect = this.originalForm.getBoundingClientRect();
    this.stickyContainer.classList.toggle('visible', rect.bottom < 0);
  }

  handleVariantChange() {
    const selectedVariant = this.getSelectedVariant();
    this.updateStickyAddToCart(selectedVariant);
  }

  getSelectedVariant() {
    const variantId = this.originalForm.querySelector('[name="id"]').value;
    return JSON.parse(this.variantSelector.querySelector('script').textContent)
      .find(variant => variant.id === Number(variantId));
  }

updateStickyAddToCart(variant) {
    if (!variant) return;

    // Update image
    if (variant.featured_image) {
      this.productInfo.querySelector('img').src = variant.featured_image.src;
    }

    // Update title
    const titleElement = this.productInfo.querySelector('h3');
    titleElement.textContent = this.productInfo.dataset.productTitle;

    // Update price and variant name
    const priceElement = this.productInfo.querySelector('.sticky-product-info__price');
priceElement.textContent = `${this.formatMoney(variant.price)}`;

    // Update button state
    this.stickyButton.disabled = !variant.available;
    this.stickyButton.textContent = variant.available ? 
      "Add to Cart" : "Sold Out";
  }

  handleStickyAddToCart() {
    this.originalForm.querySelector('[type="submit"]').click();
  }

  formatMoney(cents) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 2
    }).format(cents / 100);
  }
}

// Initialize the sticky add to cart functionality
document.addEventListener('DOMContentLoaded', () => {
  new StickyAddToCart();
});

